export const MIN_LOAN_AMOUNT_UK = 1000;
export const MAX_LOAN_AMOUNT_UK = 1000000;

export const formatLoanAmountUK = (amount: number) =>
  `£${amount.toLocaleString('en-GB')}`;

export const LOAN_DURATION_OPTIONS_UK = [
  {
    label: 'A few months',
    value: '12_months',
  },
  {
    label: 'Next 1-2 years',
    value: '24_months',
  },
  {
    label: 'Next 3+ years',
    value: '36_months',
  },
  {
    label: "I'd like to dip in and out",
    value: '48_months',
  },
  {
    label: "I'm unsure at the moment",
    value: '60_months',
  },
] as const;

export const LOAN_PURPOSE_OPTIONS_UK = [
  {
    label: 'Purchasing stock',
    value: 'stock_purchase',
  },
  {
    label: 'Paying wages',
    value: 'pay_staff',
  },
  {
    label: 'Paying a bill',
    value: 'pay_bill',
  },
  {
    label: 'Refinancing debt',
    value: 'refinancing_debt',
  },
  {
    label: 'Growing my business',
    value: 'growing_business',
  },
  {
    label: 'Supporting cash flow',
    value: 'supporting_cashflow',
  },
  {
    label: 'Other purposes',
    value: 'other',
  },
  {
    label: 'No specific need',
    value: 'no_specific_need',
  },
] as const;

export type TLoanDurationValueUK =
  (typeof LOAN_DURATION_OPTIONS_UK)[number]['value'];
export type TLoanPurposeValueUK =
  (typeof LOAN_PURPOSE_OPTIONS_UK)[number]['value'];

export const isLoanDurationValueUK = (
  value?: string | null,
): value is TLoanDurationValueUK =>
  LOAN_DURATION_OPTIONS_UK.some((option) => option.value === value);

export const isLoanPurposeValueUK = (
  value?: string | null,
): value is TLoanPurposeValueUK =>
  LOAN_PURPOSE_OPTIONS_UK.some((option) => option.value === value);

// Minimal form shape the fields require, kept independent of any single step's
// form type so multiple steps can render them.
export type TLoanFieldsDataUK = {
  amount?: string;
  loanDuration?: TLoanDurationValueUK;
  loanPurpose?: TLoanPurposeValueUK;
};
